import React from 'react';

var e = ["onlinescheduling", "@", "bilh.org"].join("");
var mt = ["mail", "to", ":", e].join("");
var p = ["781", "744", "6147"].join("-");
var t = ["tel", ":", p].join("");

export const labels = {
    home: {
        title: "Welcome to Beth Israel Lahey Health Primary Care",
        emergency: "If you are having a medical emergency, dial 911 or go to the closest emergency department.",
        newPatient: <p><b>This scheduling tool is for new patients only.</b><br />
            <br />
            <b>Existing Patients</b>, please contact your <a target="_blank" href="https://primarycare.bilh.org/">doctor's office</a> or log into <a target="_blank" href="https://bilh.org/patient-portal/mybilh-chart">MyBILH Chart</a> account to schedule.
            <br /><br />
            <b>If you are having a medical emergency, call 911 or go to the closest emergency department.</b>
            <br /><br />
            <h4>New to BILH Primary Care?</h4>            
            BILH offers both in-person and virtual primary care options to support your everyday health needs.
            <br /><br />
            <b>In-Person Primary Care</b>
            <br />
            Work with a trusted primary care provider in person at a convenient, office location near you.
            <br /><br />
            <b>Virtual Primary Care</b>
            <br />
            Connect with a virtual primary care provider through secure video visits on a smartphone, tablet, or computer without having to visit an office location. Learn more about <a href="https://bilh.org/care-options/primary-care/virtual">Virtual Primary Care</a>.
        </p>,
        who: {
            text: "Is the patient 18 years or older?",
            options: ["Yes", "No"],
        },
        age: {
            error: "Please enter a valid age",
            placeholder: "Years",
            labels: {
                "1": "Patient's Age (For newborn enter 0)",
                "2": "Patient's Age (For newborn enter 0)"
            }
        },
        virtualist: {
            text: "Choose the Type of Care You Prefer",
            description: "Select how you'd like to receive care on an ongoing basis:",
            options: [
                { text : "In-Person Primary Care", description: "Choose a provider you'll see at a physical location" },
                { text: "Virtual-Only Primary Care", description: "Choose a provider you'll see entirely online — no office visits required" }
            ]
        },
        visitReason: {
            title: "Appointment Information",
            text: "What kind of appointment is this?",
            values: [
                "Annual physical exam or check-up",
                "Visit to discuss a specific health issue"
            ]
        },
        search: {
            title: "Find a provider",
            text: "Look for providers near you, or search for a specific provider or practice by name."
        },
        searchButton: {
            text: "Find Providers"
        },
        alert: {
            physical: <>Scheduling an annual physical? Make sure your appointment is at least one year after your last physical.</>,
            specificIssue: <>If you are having a medical emergency, call 911 or go to the closest emergency department. If you have COVID-19 symptoms or have recently been exposed to someone who tested positive for COVID-19, call us at <a style={{ whiteSpace: "nowrap" }} href={t}>{p}</a>.</>,
            newborn: <>If you are a parent or guardian trying to schedule a visit for a newborn baby, please ensure that you are scheduling this visit within the specific time frame recommended by the discharging birth center, nursery, hospital, or clinician.  If there is no availability in that time frame, please either select another clinician or contact the practice directly to inquire about additional availability.</>,
            continue: "Continue"
        }
    },
    searchbar: {
        zipCity: "Zip Code or City",
        providerPractice: "Provider or Practice",
        invalidSearch: "Please enter a location, provider, or practice",
        invalidLocation: "Location not found",
        invalidProviderPractice: "Please select a provider or practice",
        searchButton: "Search"
    },
    search: {
        newSearch: "Start New Search",
        locationResults: "Displaying ${numResults} results within ${miles} miles of ${place}",
        locationResult: "Displaying 1 result within ${miles} miles of ${place}",
        providerPracticeResults: "Displaying ${numResults} results for ${providerPractice}",
        providerPracticeResult: "Displaying 1 result for ${providerPractice}",
        instruction: "Want to learn more about a provider's education, languages spoken and insurances accepted? Click their name or photo for details",
        noAppointments: (clinic, phone) => <>This provider currently has no appointments available.  Please call <b>{clinic}</b> at <b style={{ whiteSpace: "nowrap" }}><a href={"tel:" + phone}>{phone}</a></b> to book with another provider at this location.</>,
        insurance: "Insurance",
        moreFilters: "More Filters",
        appointmentType: "Type of Care",
        choose: "Choose",
        inPerson: "In\xa0Person",
        virtualVisit: "Virtual",
        fad: (ageCutoff) => <>If you are having a medical emergency, dial 911 or go to the closest emergency department.</>,
        fadAlert: (ageCutoff) => <>{ageCutoff > 0 && <>This primary care provider is only accepting new patients {ageCutoff} years and older. </>}
            To see more primary care providers, <a href="./">start a new search</a>.</>,
        ageCutoff: (ageCutoff) => <>This primary care provider is only accepting new patients {ageCutoff} years and older. To see more primary care providers, <a style={{ color: "white", textDecoration: "underline" }} href="./">start a new search</a>.</>
    },
    newpatient: {
        heading: "Is ${firstName} ${lastName}${title} currently your primary care provider?",
        currentProvider: "I am a current patient of this primary care provider",
        notCurrentProvider: "I am a new patient"
    },
    appointmentinfo: {

    },
    formprogress: {

    },
    provider: {
        backTo: "Back to Search Results",
        generalInfo: "General Info",
        boardCertifications: "Board Certifications",
        academicTitles: "Academic Titles",
        languagesSpoken: "Languages Spoken",
        gender: "Gender",
        genders: { male: "Male", female: "Female", other: "Other" },
        education: "Education",
        clinicalInterests: "Additional Clinical Interests",
        otherServices: "Other Services Offered at This Clinic",
        insuranceAccepted: "Insurance Accepted",
        phone: "Phone",
        ageCutoff: "Currently accepting new patients ${ageCutoff} years and older",
        noCutoff: "Currently accepting all new patients"
    },
    personalinfo: {
        personalInformation: "Personal Information",
        details: "The details of the appointment are below.",
        firstName: "Legal First Name",
        lastName: "Legal Last Name",
        dob: "Date of Birth",
        dobPlaceHolder: "MM/DD/YYYY",
        legalSex: "Legal Sex",
        genderIdentity: "Gender Identity",
        preferredLanguage: "Preferred Language",
        other: "Other",
        otherLanguage: "Other Language",
        otherLanguagePlaceholder: "Specify Language",
        address1: "Address",
        address1Placeholder: "123 Main St",
        address2: "Address 2",
        address2Placeholder: "Apartment or Suite",
        city: "City",
        state: "State",
        zipcode: "Zip Code",
        zipcodePlaceholder: "01234",
        continue: "Continue",
        backTo: "Back",
        ageCutoff: (ageCutoff) => `This provider is only accepting new patients ${ageCutoff} years and older. Please <a href="./">search for another provider</a>.`
    },
    contactinfo: {
        title: "Contact Information",
        instructions: ["Please provide an email address, and either a cell phone or home phone number for clinic outreach and verification.",
                    "Please select a method to verify your contact information."],
        verificationMethod: "Verification Method",
        dataRate: "(message and data rates may apply)",
        verificationText: "We will send you a code to verify your contact information. How would you like to receive this code?",
        emailVerificationText: "We will send you a code to verify your contact information.",
        verificationMethods: [
            { name: "Text", value: "Send verification code by text to your cell phone", dataRateApply: true },
            { name: "Email", value: "Send verification code to your email", dataRateApply: false},
            { name: "Both Text & Email", value: "", dataRateApply: true }
        ],
        email: "Email",
        cellPhone: "Cell Phone",
        homePhone: "Home Phone",
        backTo: "Back"
    },
    insuranceinfo: {
        carrier: "Health Insurance",
        memberId: "Member ID",
        groupNumber: "Group Number",
        relationshipToSubscriber: "Relationship to Subscriber",
        subscriberName: "Subscriber Name",
        subscriberId: "Subscriber ID",
        subscriberDob: "Subscriber Date of Birth",
        subscriberDobPlaceholder: "MM/DD/YYYY",
        continue: "Schedule Appointment",
        waitButon: "Scheduling Appointment...",
        relationshipOptions: [ "Self", "Spouse", "Child/Dependent"],
        backTo: "Back",
        notice: <p>Beth Israel Lahey Health abides by federal and state laws which aim at preventing unanticipated healthcare bills
            (sometimes referred to as "balance" or "surprise" medical bills). When you see a health care provider, you may owe
            certain out-of-pocket costs, such as a copayment, coinsurance, and/or a deductible. You may have other costs or have
            to pay the entire bill if you see a provider or visit a health care facility that isn't in your health plan's network.<br /><br />
            <a target="_blank" href="http://bilh.org/-/media/files/bilh/balance-billing-notice.pdf">Click here for a guide to your rights and protections against surprise medical bills [PDF]. </a>
        </p>
    },
    bookingcomplete: {
        title: "Your appointment is scheduled.",
        heading: "What to expect",
        message: (phone) => <><p>Check your email or text messages for your scheduled appointment information. Remember to check your spam folder if you don't see an email from
                us in your inbox. If your appointment is virtual, we will send you instructions for starting your visit</p>
            <p>Before your appointment, a member of our team will contact you to complete your new patient registration, gather any additional information,
                and confirm your appointment. You may also need to update your primary care provider on record with your insurance carrier and transfer medical records to your new doctor.
            </p>
            <p>If you need to reschedule or cancel your appointment, call the clinic at <a href={"tel:" + phone}>{phone}</a>.</p>
        </>
    },
    virtualistbookingcomplete: {
        title: "Your appointment is scheduled.",
        heading: "What to expect",
        message: (phone) => <><p>If you do not have a MyBILH Chart patient portal account, you will need to create one before your appointment.  Please use the following link and follow the instructions to create your account.
            <br/><br/>
            <a href="https://mychart.bilh.org/MyChart-BILH/Signup">https://mychart.bilh.org/MyChart-BILH/Signup</a>
            </p>
            <p>If you need assistance with creating a MyBILH Chart account, please call 877-270-0370.</p>
            <p>Before your appointment, a member of our team will contact you to complete your new patient registration, gather any additional information, and confirm your appointment.  You may also need to update your primary care provider on record with your insurance carrier, in select cases we may assist you with this process. You may also need to transfer medical records to your new provider.</p>
            <p style={{ fontWeight: "bold" }}>YOU WILL NEED TO LOG INTO MYBILH CHART TO JOIN YOUR VIRTUAL VISIT.</p>
            <p style={{ fontWeight: "bold" }}>To help us provide the best care during your virtual visit, it is ideal (though not required) to have a blood pressure cuff and home scale.</p>
            <p>If you need to reschedule or cancel your appointment, call Virtual Primary Care at 781-825-8674.
            </p>
        </>
    },
    general: {
        callcenter: <>If you need help scheduling your appointment, call us at <a style={{ whiteSpace: "nowrap" }} href={t}>{p}</a> or email <a href={mt}>{e}</a></>
    },
    contactprovider: {
        unexpectedError: <p>We encountered an unexpected problem. Please <a href="./">start a new provider search</a> and try again. If you need help scheduling your appointment, call us at <a style={{ whiteSpace: "nowrap" }} href={t}>{p}</a> or email <a href={mt}>{e}</a></p>,
        systemError: (provider, phone, backto)  => <p>We could not book this appointment through our system at this time. Please contact the practice directly to schedule an appointment at <a style={{ whiteSpace: "nowrap" }} href={"tel:" + phone}>{phone}</a>.</p>,
        invalidAppt: (provider, phone, backto) => <p>This time slot has been taken. Please <a href={backto}>choose another time slot</a> or call {provider}'s office at <a style={{ whiteSpace: "nowrap" }} href={"tel:" + phone}>{phone}</a> to speak with the clinic staff. We apologize for the inconvenience.</p>,
        bookingError: <p>We encountered an unexpected technical issue. If you need help scheduling your appointment, call us at <a style={{ whiteSpace: "nowrap" }} href={t}>{p}</a> or email <a href={mt}>{e}</a></p>,
        possibleBot: <p>Thank you for choosing to use the BILH Online Appointment Scheduler tool. We've detected unusual browser activities. If you need help scheduling your appointment, call us at <a style={{ whiteSpace: "nowrap" }} href={t}>{p}</a> or email <a href={mt}>{e}</a></p>,
        currentPatient: <><p>We're sorry, this online appointment scheduling form is for new patients of Beth Israel Lahey Health primary care providers.
            Current patient can schedule an appointment by <a target="_blank" href="https://primarycare.bilh.org/">contacting your doctor</a>
            or <a target="_blank" href="https://bilh.org/locations?filters=Primary%20Care&listPage=1">primary care location</a>, or log into your <a target="_blank" href="https://bilh.org/patient-portal">patient portal account</a>.            
        </p></>
    }
}